/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Ptz_ErrorInputs */

const vi_grower_area_camera_ptz_error = /** @type {(inputs: Grower_Area_Camera_Ptz_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gửi được lệnh điều khiển tới camera`)
};

/**

* @param {Grower_Area_Camera_Ptz_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_ptz_error = /** @type {((inputs?: Grower_Area_Camera_Ptz_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Ptz_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_ptz_error(inputs)
});